export function checkUrl (url: string): boolean {
    try {
       new URL (url);
    } catch (error) {
       return false; 
    }
    return true;
  }